/* Shared progressive gallery controls: no tracking, no API writes, no new image content. */
(() => {
 'use strict';
 function init(root=document){
  root.querySelectorAll('[data-pa-gallery-panel]').forEach(panel=>{
   if(panel.dataset.galleryBound)return;
   panel.dataset.galleryBound='true';
   const gallery=panel.querySelector('.pa-gallery');
   const items=[...panel.querySelectorAll('.pa-gallery-item')];
   const thumbs=[...panel.querySelectorAll('[data-pa-gallery-thumb]')];
   const count=panel.querySelector('[data-pa-gallery-count]');
   if(!gallery||!items.length){if(count)count.textContent='No media';panel.querySelectorAll('[data-pa-gallery-prev],[data-pa-gallery-next]').forEach(b=>b.disabled=true);return;}
   let current=0;
   function sync(index){
    current=Math.max(0,Math.min(items.length-1,index));
    thumbs.forEach((t,i)=>t.setAttribute('aria-current',String(i===current)));
    if(count)count.textContent=String(current+1).padStart(2,'0')+' / '+String(items.length).padStart(2,'0')+' views';
   }
   function move(index){
    if(!items.length)return;
    const next=(index+items.length)%items.length;
    sync(next);
    const motion=matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
    if(matchMedia('(max-width: 760px)').matches){
     const delta=items[next].getBoundingClientRect().left-gallery.getBoundingClientRect().left;
     gallery.scrollTo({left:gallery.scrollLeft+delta,behavior:motion});
    }else{
     const top=items[next].getBoundingClientRect().top+window.scrollY-116;
     window.scrollTo({top:Math.max(0,top),behavior:motion});
    }
   }
   thumbs.forEach((button,i)=>button.addEventListener('click',()=>move(i)));
   panel.querySelector('[data-pa-gallery-prev]')?.addEventListener('click',()=>move(current-1));
   panel.querySelector('[data-pa-gallery-next]')?.addEventListener('click',()=>move(current+1));
   let frame=0;
   gallery.addEventListener('scroll',()=>{
    if(!matchMedia('(max-width: 760px)').matches||frame)return;
    frame=requestAnimationFrame(()=>{
     frame=0;const left=gallery.getBoundingClientRect().left;
     let index=0,distance=Infinity;
     items.forEach((item,i)=>{const d=Math.abs(item.getBoundingClientRect().left-left);if(d<distance){distance=d;index=i}});
     sync(index);
    });
   },{passive:true});
   sync(0);
  });
 }
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
